import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CommandPaletteState {
  isOpen: boolean
  query: string
  recentSearches: string[]
  open: () => void
  close: () => void
  toggle: () => void
  setQuery: (query: string) => void
  addRecentSearch: (query: string) => void
  clearRecentSearches: () => void
}

const MAX_RECENT_SEARCHES = 5

export const useCommandPaletteStore = create<CommandPaletteState>()(
  persist(
    (set) => ({
      isOpen: false,
      query: '',
      recentSearches: [],

      open: () => set({ isOpen: true, query: '' }),
      close: () => set({ isOpen: false, query: '' }),
      toggle: () => set((state) => ({ isOpen: !state.isOpen, query: state.isOpen ? '' : state.query })),

      setQuery: (query) => set({ query }),

      addRecentSearch: (query) =>
        set((state) => {
          if (!query.trim()) return state
          // Remove duplicates and add to front
          const filtered = state.recentSearches.filter(
            (s) => s.toLowerCase() !== query.toLowerCase()
          )
          const updated = [query, ...filtered].slice(0, MAX_RECENT_SEARCHES)
          return { recentSearches: updated }
        }),

      clearRecentSearches: () => set({ recentSearches: [] }),
    }),
    {
      name: 'command-palette-storage',
      partialize: (state) => ({ recentSearches: state.recentSearches }),
    }
  )
)
